import React, { useEffect, useState } from 'react';
import '../styles/GHLSetup.css';
import { Header, Footer, Loading, Button } from '../components';
import { checkOnAuthStateChanged, cloudFunctionV2 } from '../functions';
import { useNavigate, useSearchParams } from 'react-router-dom';

function GHLSetup() {
    const [loggedIn, setLoggedIn] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams({});
    const getCode = searchParams.get("code");
    const code = getCode === null ? "" : getCode;
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        document.title = "Go High Level Setup";
        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setLoggedIn(true);
            }
            else {
                setLoggedIn(false);
            }
            getGHLKeys();
        }

        const getGHLKeys = async() => {
            const url = process.env.REACT_APP_GET_GHL_KEYS;
            const params = {
                code: code,
                refreshToken: null
            };
            const queryData = await cloudFunctionV2(url, params);
            if ( queryData.status === 200 ) {
                setSuccess(true);
            }
            else {
                setSuccess(false);
            }
        };


        if ( code === "" ) {
            navigate("/");
        }
        else if ( loggedIn === null ) {
            fetchUserData();
        }

    }, [navigate, code, loggedIn]);

    const goHome = () => {
        navigate("/");
    };

    return (
        <div className="ghl-setup-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            <div className="ghl-setup-inner-container">
                <div className="ghl-setup-title-container">
                    <h1 className="heading-large-bold colour-primary text-align-center">
                        Go High Level Setup
                    </h1>
                </div>
                {
                    success === true ?
                    <div className="ghl-setup-body-container">
                        <span className="heading-small-regular colour-primary text-align-center">
                            Go High Level has been successfully setup.
                        </span>
                        <Button
                            buttonType="primary-button"
                            size="large"
                            text={"Go Home"}
                            cta={() => goHome()}
                            disabled={false}
                            leftIcon={null}
                            leftIconClass=""
                            rightIcon={null}
                            rightIconClass=""
                            alt=""
                            standardIcon={false}
                            badge={false}
                            badgeVal={null}
                            badgeBG={null}
                            buttonRef={null}
                            spinner={false}
                        />
                    </div>
                    :
                    success === false ?
                    <div className="ghl-setup-body-container">
                        <span className="heading-small-regular colour-error text-align-center">
                            There was an error setting up Go High Level - you may have opened an old link.
                        </span>
                        <Button
                            buttonType="primary-button"
                            size="large"
                            text={"Go Home"}
                            cta={() => goHome()}
                            disabled={false}
                            leftIcon={null}
                            leftIconClass=""
                            rightIcon={null}
                            rightIconClass=""
                            alt=""
                            standardIcon={false}
                            badge={false}
                            badgeVal={null}
                            badgeBG={null}
                            buttonRef={null}
                            spinner={false}
                        />
                    </div>
                    :
                    <div className="ghl-setup-body-container">
                        <Loading />
                    </div>
                }
            </div>
            <Footer />
        </div>
    )
};

export default GHLSetup;